import { useQuery } from '@tanstack/react-query';
import type { UseQueryOptions } from '@tanstack/react-query';
import { DEFAULT_LIMIT_REQUEST } from '@/Constants';
import { objectNotNullV2 } from '@/Utils/FnUtils';
import { handleResponseThrowError } from '@/_utils/services';
import type { Delivery, GetDeliveriesListParams } from '../types';
import { GET_DELIVERIES_LIST } from '../constants';
import type { BaseRequestResponse } from '@/_types/services';
import { apiClient } from '@/_config/lib/axios/api-client';

// TODO: Remove this function, data should be transformed before being sent to the API
const transformParams = (params: GetDeliveriesListParams) => {
  const {
    limit,
    startDate,
    endDate,
    code,
    status,
    cityId,
    motoboyId,
    placeId,
    page,
    deliveryType,
    deliveryId,
    billingType,
  } = params || {};

  const newPage = page || 1;
  const newLimit = limit || DEFAULT_LIMIT_REQUEST;
  const offset = (newPage - 1) * newLimit;

  return objectNotNullV2({
    limit: newLimit,
    offset,
    estabelecimentoId: placeId,
    entregaId: deliveryId,
    entregadorId: motoboyId,
    municipioId: cityId,
    dataInicio: startDate ? new Date(startDate).toISOString() : '',
    dataFim: endDate ? new Date(endDate).toISOString() : '',
    codigo: code,
    status,
    deliveryType,
    billingType,
  });
};

const getDeliveries = (params: GetDeliveriesListParams) => {
  const objParams = transformParams(params);

  return apiClient
    .get<BaseRequestResponse<Delivery[]>>(`/entregas/list-deliveries`, {
      params: objParams,
    })
    .then(response => response.data)
    .catch(handleResponseThrowError());
};

type GetDeliveriesListData = Awaited<ReturnType<typeof getDeliveries>>;

export const useGetDeliveriesList = (
  params: GetDeliveriesListParams,
  options: Omit<
    UseQueryOptions<
      GetDeliveriesListData,
      unknown,
      GetDeliveriesListData,
      (string | GetDeliveriesListParams)[]
    >,
    'queryKey' | 'queryFn'
  > = {},
) => {
  return useQuery({
    queryKey: [GET_DELIVERIES_LIST, params],
    queryFn: () => getDeliveries(params),
    ...options,
  });
};
